import { render } from "./Transfer.vue?vue&type=template&id=01701f48&scoped=true"
import script from "./Transfer.vue?vue&type=script&lang=js"
export * from "./Transfer.vue?vue&type=script&lang=js"

import "./Transfer.vue?vue&type=style&index=0&id=01701f48&lang=less&scoped=true"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01701f48"]])

export default __exports__